import { Box } from 'v1/ui';

export function Layout({ children }: { children: React.ReactNode }) {
  return (
    <Box
      sx={{
        width: '100vw',
        height: '100vh',
      }}
    >
      <Box
        sx={{
          height: '100%',
          width: '100%',
          maxWidth: 1280,
          mx: 'auto',
          display: 'grid',
          gridTemplateColumns: ['1fr', '390px 1fr'],
          gridColumnGap: [16, 24, 32],
          px: [16, 24, 32],
        }}
      >
        {children}
      </Box>
    </Box>
  );
}

export function Toggle({ active }: { active: boolean }) {
  return (
    <Box
      sx={{
        position: 'relative',
        width: 32,
        height: 32,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: '8px',
          right: '8px',
          bottom: '8px',
          left: '8px',
          bg: active ? 'black' : 'transparent',
          border: '1px solid black',
          borderRadius: 999,
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          top: '5px',
          right: '5px',
          bottom: '5px',
          left: '5px',
          border: '1px solid black',
          borderColor: active ? 'black' : 'transparent',
          borderRadius: 999,
        }}
      />
    </Box>
  );
}

export function Heading({ children }: { children: React.ReactNode }) {
  return (
    <Box
      sx={{
        fontSize: [30, 34, 38],
        fontWeight: 600,
        mt: [38, 64, 96],
        mb: 32,
        lineHeight: 1.05,
      }}
    >
      {children}
    </Box>
  );
}

export function Subtext({ children }: { children: React.ReactNode }) {
  return (
    <Box variant="text.base" sx={{ color: 'black80', mb: 32 }}>
      {children}
    </Box>
  );
}

export function ColoredText({
  children,
  color,
}: {
  children: React.ReactNode;
  color: string;
}) {
  return (
    <Box as="span" sx={{ color: color }}>
      {children}
    </Box>
  );
}
